import { ManageOverviewPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/'].update({
        staticData: { title: { page: 'Manage.PageHeading' } },
        component: authGuard(ManageOverviewPage, { hasRights: true })
    });
};
